import React, { Component } from 'react'
import service from '../../services'
import SimpleReactValidator from 'simple-react-validator'
import ReactPaginate from 'react-paginate'
import Loader from '../../component/loader'
import commonImage from '../../commonImage'
import CsvUploadResultModal from './CsvUploadResultModal'
import ModalMessage from '../../component/ModalMessage'
import { Link } from 'react-router-dom'
import PlusIcon from '../../icons/plusicon'
import DeleteIcon from '../../icons/DeleteIcon'
import FpgMinusIcon from '../../icons/fpgminusicon';
import FpgPlusIcon from '../../icons/fpgplusicon';
import DropdownMaster from '../../component/DropdownMaster'
import CreatableSelect from 'react-select/creatable'
import '../../assets/scss/_access-controlled-pages.scss'
import moment from 'moment'
let sub;
export default class AccessControlledPageDetail extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loaderFlag: false,
            isEdit: false,
            recordId: null,
            initialData: null,
            lastUpdatedBy: null,
            lastUpdatedAt: '',
            name: '',
            description: '',
            status: 'active',
            pages: [{ path: '', queryParams: [] }],
            userSearchQuery: '',
            userSearchResults: [],
            selectedUsers: [],
            addingUsers: false,
            whitelistUsers: [],
            whitelistTotal: 0,
            whitelistPage: 1,
            whitelistPerPage: 10,
            pageCount: 0,
            messageModal: false,
            bulkErrorMsg: '',
            fileUploading: false,
            uploadCSVModal: false,
            totalAddedRecord: 0,
            totalSkippedRecord: 0,
            skippedUsers: [],
            removeCsvUploading: false,
            removeUploadCSVModal: false,
            totalRemovedRecord: 0,
            totalRemoveSkippedRecord: 0,
            removeSkippedUsers: [],
        }

        this.apiserve = new service()
        this.validator = new SimpleReactValidator()
        this.searchTimeout = null
        this.csvInputRef = React.createRef()
        this.removeCsvInputRef = React.createRef()
    }

    componentDidMount() {
        this.getData()
        const recordId = this.props.match.params.recordId
        if (recordId) {
            this.setState({ isEdit: true, recordId })
            this.apiserve.sendevent('accessControl|getById', { id: recordId })
        }
    }

    componentWillUnmount = () => {
        if (sub) sub.unsubscribe()
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
    }

    getData = () => {
        sub = this.apiserve.getevent().subscribe(response => {
            switch (response.event) {
                case 'accessControl|getById':
                    if (!response.error) {
                        const data = response?.data?.data || {}
                        const loadedPages = (data.pages && data.pages.length) ? data.pages : [{ path: '', queryParams: [] }]
                        const initialData = {
                            name: data.name || '',
                            description: data.description || '',
                            status: data.status || 'inactive',
                            pages: JSON.parse(JSON.stringify(loadedPages)),
                        }
                        this.setState({
                            name: initialData.name,
                            description: initialData.description,
                            status: initialData.status,
                            pages: loadedPages,
                            initialData,
                            lastUpdatedBy: data.updatedBy || null,
                            lastUpdatedAt: data.updatedAt || '',
                        }, () => {
                            this.refreshWhitelist(1)
                        })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break

                case 'accessControl|create':
                    if (!response.error && response.data) {
                        const respData = (response.data && response.data.data) ? response.data.data : (response.data || {})
                        const newId = respData.id 
                        if (newId) {
                            this.setState({
                                recordId: newId,
                                isEdit: true,
                                initialData: {
                                    name: this.state.name,
                                    description: this.state.description,
                                    status: this.state.status,
                                    pages: JSON.parse(JSON.stringify(this.state.pages)),
                                }
                            })
                            this.refreshWhitelist(1)
                        }
                        this.apiserve.success('Record created successfully.')
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break

                case 'accessControl|update':
                    if (!response.error) {
                        this.setState({
                            initialData: {
                                name: this.state.name,
                                description: this.state.description,
                                status: this.state.status,
                                pages: JSON.parse(JSON.stringify(this.state.pages)),
                            }
                        })
                        this.apiserve.sendevent('accessControl|getById', { id: this.state.recordId })
                        this.apiserve.success('Access control record updated successfully.')
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break

                case 'accessControl|getWhitelist':
                    if (!response.error) {
                        const wlData = response.data || {}
                        this.setState({
                            whitelistUsers: (wlData.data || []),
                            whitelistTotal: wlData.pagination.totalDocs || 0,
                            pageCount: Math.ceil((wlData.pagination.totalDocs || 0) / this.state.whitelistPerPage),
                        })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break

                case 'accessControl|searchUsers':
                    if (!response.error) {
                        this.setState({ userSearchResults: (response.data.data || []) })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break

                case 'accessControl|addUsers':
                    if (!response.error) {
                        const addData = (response.data && response.data.data) ? response.data.data : (response.data || {})
                        const duplicateEmails = addData.duplicateEmails || []
                        this.apiserve.sendevent('accessControl|getById', { id: this.state.recordId })
                        if (duplicateEmails.length > 0) {
                            const skippedUsers = duplicateEmails.map((email, i) => ({ row: i + 1, email, error: 'Already whitelisted' }))
                            this.setState({
                                totalAddedRecord: addData.addedCount || 0,
                                totalSkippedRecord: skippedUsers.length,
                                skippedUsers,
                                uploadCSVModal: true,
                                addingUsers: false,
                                selectedUsers: [],
                                userSearchQuery: '',
                                userSearchResults: [],
                                whitelistPage: 1,
                            })
                        } else {
                            this.setState({ addingUsers: false, whitelistPage: 1, selectedUsers: [], userSearchQuery: '', userSearchResults: [] })
                        }
                    } else {
                        this.setState({ addingUsers: false })
                        this.apiserve.error(response.data.error)
                    }
                    break

                case 'accessControl|removeUsers':
                    if (!response.error) {
                        this.apiserve.sendevent('accessControl|getById', { id: this.state.recordId })
                        this.setState({ whitelistPage: 1 })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break

                case 'accessControl|bulkUpload':
                    if (!response.error && response.data) {
                        if (response.data.success === false) {
                            this.setState({ fileUploading: false, bulkErrorMsg: response.data.error || 'Upload failed.' })
                            break
                        }
                        const d = response.data.data || response.data
                        const skippedUsers = [
                            ...(d.notFoundEmails || []).map((email, i) => ({ row: i + 1, email, error: 'User not found in system' })),
                            ...(d.invalidEmails || []).map((email, i) => ({ row: i + 1, email, error: 'Invalid email format' })),
                            ...(d.duplicateEmails || []).map((email, i) => ({ row: i + 1, email, error: 'Already whitelisted' })),
                        ]
                        this.apiserve.sendevent('accessControl|getById', { id: this.state.recordId })
                        this.setState({
                            totalAddedRecord: d.addedCount || 0,
                            totalSkippedRecord: skippedUsers.length,
                            skippedUsers,
                            uploadCSVModal: true,
                            fileUploading: false,
                        })
                    } else {
                        this.setState({ fileUploading: false })
                        this.apiserve.error(response.data.error)
                    }
                    break

                case 'accessControl|removeBulkUser':
                    if (!response.error && response.data) {
                        if (response.data.success === false) {
                            this.setState({ removeCsvUploading: false, bulkErrorMsg: response.data.error || 'Upload failed.' })
                            break
                        }
                        const d = response.data.data || response.data
                        const removeSkippedUsers = [
                            ...(d.notFoundEmails || []).map((email, i) => ({ row: i + 1, email, error: 'User not found in whitelist' })),
                            ...(d.invalidEmails || []).map((email, i) => ({ row: i + 1, email, error: 'Invalid email format' })),
                        ]
                        this.apiserve.sendevent('accessControl|getById', { id: this.state.recordId })
                        this.setState({
                            totalRemovedRecord: d.removedCount || 0,
                            totalRemoveSkippedRecord: removeSkippedUsers.length,
                            removeSkippedUsers,
                            removeUploadCSVModal: true,
                            removeCsvUploading: false,
                        })
                    } else {
                        this.setState({ removeCsvUploading: false })
                        this.apiserve.error(response.data.error)
                    }
                    break

                default:
                    break
            }
        })
    }

    handleSave = () => {
        if (this.validator.allValid()) {
            const payload = {
                name: this.state.name,
                description: this.state.description,
                status: this.state.status,
                pages: this.state.pages,
            }
            if (this.state.isEdit) {
                this.apiserve.sendevent('accessControl|update', { id: this.state.recordId, ...payload })
            } else {
                this.apiserve.sendevent('accessControl|create', payload)
            }
        } else {
            this.setState({ messageModal: true })
            this.validator.showMessages()
            this.forceUpdate()
        }
    }

    closeMessageModal = () => {
        this.setState({ messageModal: false })
    }

    hasChanges = () => {
        const { isEdit, initialData, name, description, status, pages } = this.state
        if (!isEdit || !initialData) return true
        return (
            name !== initialData.name ||
            description !== initialData.description ||
            status !== initialData.status ||
            JSON.stringify(pages) !== JSON.stringify(initialData.pages)
        )
    }

    addPage = () => {
        this.setState(prev => ({ pages: [...prev.pages, { path: '', queryParams: [] }] }))
    }

    removePage = (index) => {
        this.setState(prev => ({ pages: prev.pages.filter((_, i) => i !== index) }))
    }

    updatePagePath = (index, value) => {
        const pages = [...this.state.pages]
        pages[index] = { ...pages[index], path: value }
        this.setState({ pages })
    }

    addQueryParam = (pageIndex) => {
        const pages = [...this.state.pages]
        pages[pageIndex].queryParams = [...(pages[pageIndex].queryParams || []), { key: '', value: '' }]
        this.setState({ pages })
    }

    removeQueryParam = (pageIndex, paramIndex) => {
        const pages = [...this.state.pages]
        pages[pageIndex].queryParams = pages[pageIndex].queryParams.filter((_, i) => i !== paramIndex)
        this.setState({ pages })
    }

    updateQueryParam = (pageIndex, paramIndex, field, value) => {
        const pages = [...this.state.pages]
        pages[pageIndex].queryParams[paramIndex] = { ...pages[pageIndex].queryParams[paramIndex], [field]: value }
        this.setState({ pages })
    }

    searchUsers = (query) => {
        this.setState({ userSearchQuery: query })
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
        if (query.length > 1) {
            this.searchTimeout = setTimeout(() => {
                this.apiserve.sendevent('accessControl|searchUsers', { search: query, id: this.state.recordId })
            }, 300)
        } else {
            this.setState({ userSearchResults: [] })
        }
    }

    handleUserSelect = (selectedOptions) => {
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
        this.setState({
            selectedUsers: selectedOptions || [],
            userSearchQuery: '',
            userSearchResults: []
        })
    }

    addSelectedUsers = () => {
        const { selectedUsers } = this.state
        if (!selectedUsers || !selectedUsers.length) return
        const userIds = (selectedUsers || []).filter(u => !u.__isNew__).map(u => u.userId)
        const emails = (selectedUsers || []).filter(u => u.__isNew__).map(u => u.value)
        this.setState({ addingUsers: true })
        this.apiserve.sendevent('accessControl|addUsers', { id: this.state.recordId, userIds, emails })
    }

    removeUser = (row) => {
        if (!row.userId && !row.email) return
        const payload = row.userId
            ? { id: this.state.recordId, userIds: [row.userId], emails: [] }
            : { id: this.state.recordId, userIds: [], emails: [row.email] }
        this.apiserve.sendevent('accessControl|removeUsers', payload)
    }

    refreshWhitelist = (page = 1) => {
        this.apiserve.sendevent('accessControl|getWhitelist', {
            id: this.state.recordId,
            page,
            limit: this.state.whitelistPerPage,
            search: '',
        })
    }

    handleCsvUpload = (e) => {
        const file = e.target.files[0]
        if (!file) return;
        if ((file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') && !file.name.includes('.csv') && (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
            this.apiserve.error('Please upload a .csv file only.')
            return
        }
        this.setState({ fileUploading: true })
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = (event) => {
            setTimeout(() => {
                this.imageUploadCsv(file, event.target.result)
            }, 0)
        }
        e.target.value = ''
    }

    imageUploadCsv = (file, img) => {
        const fileSet = commonImage(file, false, this.apiserve.formbucketLocationCSV, img)
        fileSet.then((value) => {
            const s3Url = encodeURI(process.env.REACT_APP_IMAGE_URL + value)
            this.apiserve.sendevent('accessControl|bulkUpload', { id: this.state.recordId, url: s3Url })
        }).catch(() => {
            this.setState({ fileUploading: false })
            this.apiserve.error('File upload failed. Please try again.')
        })
    }

    handleRemoveCsvUpload = (e) => {
        const file = e.target.files[0]
        if (!file) return;
        if ((file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') && !file.name.includes('.csv') && (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
            this.apiserve.error('Please upload a .csv file only.')
            return
        }
        this.setState({ removeCsvUploading: true })
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = (event) => {
            setTimeout(() => {
                this.imageRemoveCsv(file, event.target.result)
            }, 0)
        }
        e.target.value = ''
    }

    imageRemoveCsv = (file, img) => {
        const fileSet = commonImage(file, false, this.apiserve.formbucketLocationCSV, img)
        fileSet.then((value) => {
            const s3Url = encodeURI(process.env.REACT_APP_IMAGE_URL + value)
            this.apiserve.sendevent('accessControl|removeBulkUser', { id: this.state.recordId, url: s3Url })
        }).catch(() => {
            this.setState({ removeCsvUploading: false })
            this.apiserve.error('File upload failed. Please try again.')
        })
    }

    handleWhitelistPageClick = ({ selected }) => {
        this.setState({ whitelistPage: selected + 1 }, () => this.refreshWhitelist(this.state.whitelistPage))
    }

    render() {
        this.validator.purgeFields();
        const {
            loaderFlag,
            isEdit,
            name,
            description,
            status,
            pages,
            userSearchQuery,
            userSearchResults,
            selectedUsers,
            addingUsers,
            whitelistUsers,
            whitelistPage,
            whitelistPerPage,
            fileUploading,
            uploadCSVModal,
            totalAddedRecord,
            totalSkippedRecord,
            skippedUsers,
            recordId,
            pageCount,
            removeCsvUploading,
            removeUploadCSVModal,
            totalRemovedRecord,
            totalRemoveSkippedRecord,
            removeSkippedUsers,
        } = this.state

        return (
            <div className="right_side_wrapper">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_center">
                            <div>{isEdit ? 'EDIT ACCESS CONTROL RECORD' : 'CREATE ACCESS CONTROL RECORD'}</div>
                        </p>
                    </li>
                </ul>

                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                    <Link className="back_link" to="/access-controlled-pages">
                        <svg width="5" height="10" viewBox="0 0 5 10" fill="none">
                            <path d="M5 0L0 5L5 10V0Z" fill="black" />
                        </svg>
                        Back to List
                    </Link>
                    {isEdit && this.state.lastUpdatedAt && (
                        <p className="update_date">
                            Last Update: {moment(this.state.lastUpdatedAt).format('h')}:{moment(this.state.lastUpdatedAt).format('mm')} {moment(this.state.lastUpdatedAt).format('A')} - {moment(this.state.lastUpdatedAt).format('MM/DD/YY')} by {(this.state.lastUpdatedBy && this.state.lastUpdatedBy.fname) + ' ' + (this.state.lastUpdatedBy && this.state.lastUpdatedBy.lname)}
                        </p>
                    )}
                </div>

                <div className="fpg_tabcontent pl_15 about_sundance acp-form-wrapper">
                    <form onSubmit={(e) => { e.preventDefault(); this.handleSave(); }}>
                        <div>
                            <div className="d_flex d_flex_justify_spacebt pb_15 mb_10 acp-sections-row">
                                {/* Section 1 — Record Info */}
                                <div className="acp-record-info">
                                    <div className="field_row horizontal_field">
                                        <div className="field_row_inner">
                                            <label>Name <span className="required"></span></label>
                                            <div className="field_input">
                                                <input
                                                    type="text"
                                                    className="input_field"
                                                    placeholder="Enter record name"
                                                    name="name"
                                                    value={name}
                                                    onChange={(e) => this.setState({ name: e.target.value })}
                                                />
                                            </div>
                                            <span className='error d_block w_100'>{this.validator.message('name', name, 'required')}</span>
                                        </div>
                                    </div>

                                    <div className="field_row horizontal_field">
                                        <div className="field_row_inner">
                                            <label>Description</label>
                                            <div className="field_input">
                                                <textarea
                                                    className="input_field"
                                                    placeholder="Enter description"
                                                    name="description"
                                                    rows={4}
                                                    value={description}
                                                    onChange={(e) => this.setState({ description: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Section 2 — Restricted Pages */}
                                <div className="acp-restricted-pages">
                                    <div className="field_row horizontal_field pl_15">
                                        <div className="field_row_inner">
                                            <label className="uppercase acp-restricted-label-row">Restricted Pages</label>
                                            <span onClick={this.addPage} title="Add Page" className='pointer ml_10' style={{height:'20px'}}>
                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#000" stroke="#fff" />
                                            </span>
                                        </div>
                                    </div>
                                    {(pages || []).map((page, pageIndex) => (
                                        <div key={pageIndex} className="field_row horizontal_field pl_15" >
                                            <div className="field_row_inner">
                                                <label>Page Path <span className="required"></span></label>
                                                <div className="field_input d_flex d_flex_align_center">
                                                    <input
                                                        type="text"
                                                        className="input_field acp-page-path-input"
                                                        placeholder="/example-path"
                                                        value={page.path}
                                                        onChange={(e) => this.updatePagePath(pageIndex, e.target.value)}
                                                    />
                                                    {pages.length > 1 && (
                                                        <span
                                                            onClick={() => this.removePage(pageIndex)}
                                                            className='pointer ml_10'
                                                        >
                                                            <FpgMinusIcon className="pointer" width="20" height="20" color="#000" stroke="#fff" />
                                                        </span>
                                                    )}
                                                </div>

                                                <span
                                                    type="button"
                                                    onClick={() => this.addQueryParam(pageIndex)}
                                                    className='pointer d_flex d_flex_align_center justify_center ml_15'
                                                    >
                                                    + Add Query Param
                                                </span>
                                                <span className="error d_block w_100">{this.validator.message(`path_${pageIndex}`, page.path, 'required')}</span>
                                            </div>
                                            {/* Query Params */}
                                            {(page.queryParams || []).map((param, paramIndex) => (
                                                <div key={paramIndex} className="field_row horizontal_field d_flex d_flex_align_center mt_10 acp-query-param-row">
                                                    <div className="field_row_inner">
                                                        <div className="field_input">
                                                            <input
                                                                type="text"
                                                                className="input_field"
                                                                placeholder="Key"
                                                                value={param.key}
                                                                onChange={(e) => this.updateQueryParam(pageIndex, paramIndex, 'key', e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="field_row_inner">
                                                        <div className="field_input">
                                                            <input
                                                                type="text"
                                                                className="input_field"
                                                                placeholder="Value"
                                                                value={param.value}
                                                                onChange={(e) => this.updateQueryParam(pageIndex, paramIndex, 'value', e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <span
                                                        onClick={() => this.removeQueryParam(pageIndex, paramIndex)}
                                                        className="pointer acp-query-param-remove"
                                                    >
                                                        <FpgMinusIcon width="20" height="20" color="#000" stroke="#fff" />
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Section 3 — User Whitelist */}
                            <div className="field_row horizontal_field">
                                <div className="field_row_inner">
                                    <div className="d_flex d_flex_align_center d_flex_justify_spacebt">
                                        <label className="uppercase">User Whitelist</label>
                                        {recordId && (
                                            <div className="d_flex d_flex_align_center acp-whitelist-actions">
                                                <div className="acp-user-select-wrapper select_field">
                                                    <CreatableSelect
                                                        isMulti
                                                        placeholder="Search by name or email, or type an email to add..."
                                                        inputValue={userSearchQuery}
                                                        onInputChange={(val, { action }) => {
                                                            if (action === 'input-change') this.searchUsers(val)
                                                        }}
                                                        onChange={this.handleUserSelect}
                                                        options={(userSearchResults || []).map(u => ({
                                                            value: u.email,
                                                            label: `${u.fname} ${u.lname} (${u.email})`,
                                                            isDisabled: u.isEmailExists,
                                                            userId: u._id
                                                        }))}
                                                        isOptionDisabled={(option) => option.isDisabled}
                                                        value={selectedUsers}
                                                        filterOption={() => true}
                                                        noOptionsMessage={() => userSearchQuery.length > 1 ? 'No users found. Press Enter to add this email.' : 'Type to search or enter an email...'}
                                                        isValidNewOption={(inputValue) => {
                                                            if (userSearchResults && userSearchResults.length > 0) return false
                                                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                                                            return emailRegex.test(inputValue.trim())
                                                        }}
                                                        formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                                    />
                                                </div>
                                                <button
                                                    type="button"
                                                    className={'active'}
                                                    onClick={this.addSelectedUsers}
                                                    disabled={!selectedUsers || !selectedUsers.length || addingUsers}
                                                >
                                                    {addingUsers ? 'Adding...' : 'Add User'}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="active"
                                                    disabled={fileUploading}
                                                    onClick={() => this.csvInputRef.current && this.csvInputRef.current.click()}
                                                >
                                                    {fileUploading ? 'Uploading...' : 'Upload CSV'}
                                                </button>
                                                <input
                                                    type="file"
                                                    accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    ref={this.csvInputRef}
                                                    className="d_none"
                                                    onChange={this.handleCsvUpload}
                                                />
                                                <button
                                                    type="button"
                                                    className="active"
                                                    disabled={removeCsvUploading}
                                                    onClick={() => this.removeCsvInputRef.current && this.removeCsvInputRef.current.click()}
                                                >
                                                    {removeCsvUploading ? 'Uploading...' : 'Remove via CSV'}
                                                </button>
                                                <input
                                                    type="file"
                                                    accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    ref={this.removeCsvInputRef}
                                                    className="d_none"
                                                    onChange={this.handleRemoveCsvUpload}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    {!recordId ? (
                                        <p className="mt_10 d_block w_100">Save the record first to manage users.</p>
                                    ) : (
                                        <div>
                                            <div className="table_wrap dashboard_data film_list_table striped_table mt_10 acp-whitelist-table">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Email</th>
                                                            <th>Name</th>
                                                            <th>Added Method</th>
                                                            <th>Added At</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(whitelistUsers || []).map((row) => (
                                                            <tr key={row.userId || row._id}>
                                                                <td>{row.email}</td>
                                                                <td>{(row.fname && row.lname) ?  row.fname + ' ' + row.lname : '-'}</td>
                                                                <td>{row.addedMethod}</td>
                                                                <td>{row.addedAt ? new Date(row.addedAt).toLocaleDateString() : ''}</td>
                                                                <td>
                                                                    <span className="pointer" onClick={() => this.removeUser(row)}><DeleteIcon /></span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {(!whitelistUsers || whitelistUsers.length === 0) && (
                                                    <div className="no_data_found text_center mt_25">
                                                        <p>No whitelisted users found.</p>
                                                    </div>
                                                )}
                                                {pageCount >= 1 && (
                                                    <div className="custom-pagination">
                                                        <ReactPaginate
                                                            previousLabel={""}
                                                            nextLabel={""}
                                                            breakLabel={"..."}
                                                            breakClassName={"break-me"}
                                                            pageCount={pageCount || 1}
                                                            marginPagesDisplayed={2}
                                                            pageRangeDisplayed={5}
                                                            onPageChange={this.handleWhitelistPageClick}
                                                            containerClassName={"pagination"}
                                                            subContainerClassName={"pages pagination"}
                                                            activeClassName={"active"}
                                                            forcePage={whitelistPage - 1}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>

                        {/* Save / Cancel buttons */}
                        <div className="text_center field_row w_100 buttons_outer mb_0">
                            <button
                                className="grayBTN"
                                type="button"
                                onClick={() => this.props.history.push('/access-controlled-pages')}
                            >
                                Cancel
                            </button>
                            <button
                                className={(loaderFlag || !this.hasChanges()) ? '' : 'active'}
                                type="submit"
                                disabled={loaderFlag || !this.hasChanges()}
                            >
                                {isEdit ? 'Update' : 'Submit'}
                            </button>
                        </div>
                    </form>
                </div>

                <CsvUploadResultModal
                    isOpen={uploadCSVModal}
                    onClose={() => this.setState({ uploadCSVModal: false })}
                    totalAdded={totalAddedRecord}
                    totalSkipped={totalSkippedRecord}
                    skippedUsers={skippedUsers}
                />
                <CsvUploadResultModal
                    isOpen={removeUploadCSVModal}
                    onClose={() => this.setState({ removeUploadCSVModal: false })}
                    totalAdded={totalRemovedRecord}
                    totalSkipped={totalRemoveSkippedRecord}
                    skippedUsers={removeSkippedUsers}
                    actionLabel="removed"
                />

                {this.state.bulkErrorMsg && (
                    <ModalMessage
                        messageModal={!!this.state.bulkErrorMsg}
                        withoutEmail={this.state.bulkErrorMsg}
                        ClosemessageModal={() => this.setState({ bulkErrorMsg: '' })}
                    />
                )}
                {this.state.messageModal && (
                    <ModalMessage
                        messageModal={this.state.messageModal}
                        withoutEmail="Some or all of the required fields are missing. Please check and resubmit."
                        ClosemessageModal={this.closeMessageModal}
                    />
                )}
                {loaderFlag && <Loader />}
            </div>
        )
    }
}
